import { makeAutoObservable } from 'mobx';

export class TranslationStore {
	constructor() {
		makeAutoObservable(this);
	}
}

export const translationStore = new TranslationStore();
